<template>
  <tr :class="['value-type-' + valueType, valueObjectName ? 'value-object-' + valueObjectName : '']">
    <td>{{ label }}</td>
    <td>{{ valueDisplay }}</td>
  </tr>
</template>

<script>
export default {
  name: 'DebugValueRow',
  props: {
    label: {
      type: String,
      required: false,
    },
    value: {
      required: false,
    },
  },
  computed: {
    valueType() {
      if (this.value === undefined) {
        return 'undefined';
      } else if (this.value === null) {
        return 'null';
      }

      return typeof this.value;
    },
    valueObjectName() {
      if (this.valueType !== 'object') {
        return null;
      }

      if (!this.value.constructor) {
        return null;
      }

      return this.value.constructor.name;
    },
    valueDisplay() {
      if (this.value === undefined) {
        return '(undefined)';
      } else if (this.value === null) {
        return '(null)';
      }

      if (this.valueType === 'boolean') {
        return this.value ? '(true)' : '(false)';
      }

      if (this.valueType === 'object') {
        return JSON.stringify(this.value, null, ' ');
      }

      return this.value;
    }
  }
}
</script>
